<template>
  <div class="card z-index-2">
    <div class="p-3 pb-0 card-header text-center">
      <h6 style="font-size: 0.8rem">{{ title }}</h6>
    </div>
    <div class="p-3 card-body">
      <div class="row">
        <div class="col-6 px-0">
          <div class="d-flex flex-column justify-content-between">
            <div
              v-for="label of chart.labels"
              :key="label"
              class="d-flex flex-column justify-content-center ps-1 cursor-default bar-label-container my-tooltip"
              :style="{ height: `${barHeight}px`, textAlign: 'end' }"
            >
              <h6 class="m-0" :style="{ color: '#9ca2b7', fontSize: '12.6px' }">
                {{ label }}
              </h6>
              <!-- <span class="my-tooltiptext">{{ label }}</span> -->
            </div>
          </div>
        </div>
        <div class="col-6 ps-0">
          <div class="chart" :style="{ height: `${height}px`, width: 'auto' }">
            <canvas :id="id" class="chart-canvas"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
// import * as ChartDataLabels  from 'chartjs-plugin-datalabels';
import * as utils from "@/utils/utils";
export default {
  name: "BarChartHorizontal",
  props: {
    id: {
      type: String,
      default: "bar-chart-horizontal",
    },
    height: {
      type: String,
      default: "300",
    },
    title: {
      type: String,
      default: "",
    },
    chart: {
      type: Object,
      required: true,
      labels: Array,
      datatype: String,
      chartColor: String,
      datasets: {
        type: Object,
        required: true,
        label: String,
        data: Array,
      },
    },
    onBarClick: {
      type: Function,
      required: false,
      default: () => {},
    },
    showPercentageSignInValue: {
      type: Boolean,
      required: false,
      default: false,
    },
    nameCropValue: {
      type: Number,
      required: false,
      default: 50,
    },
    barCursorType: {
      type: String,
      required: false,
      default: "default",
    },
  },
  data() {
    return { barHeight: 0 };
  },
  watch: {
    chart: {
      handler: function () {
        this.updateChart();
      },
      deep: true,
    },
  },
  mounted() {
    this.updateChart();
  },
  methods: {
    getOrCreateTooltip(chart) {
      let tooltipEl = chart.canvas.parentNode.querySelector("div");

      if (!tooltipEl) {
        tooltipEl = document.createElement("div");
        tooltipEl.style.background = "rgba(0, 0, 0, 0.7)";
        tooltipEl.style.borderRadius = "3px";
        tooltipEl.style.color = "white";
        tooltipEl.style.opacity = 1;
        tooltipEl.style.pointerEvents = "none";
        tooltipEl.style.position = "absolute";
        tooltipEl.style.transform = "translate(-50%, 0)";
        tooltipEl.style.transition = "all .1s ease";

        const table = document.createElement("table");
        table.style.margin = "0px";

        tooltipEl.appendChild(table);
        chart.canvas.parentNode.appendChild(tooltipEl);
      }

      return tooltipEl;
    },
    updateBarHeight(height) {
      if (this.barHeight != height) {
        this.barHeight = height;
      }
    },
    updateChart() {
      // Bar chart horizontal
      const canvas = document.getElementById(this.id);
      const updateBarHeightFunc = this.updateBarHeight;
      if (canvas) {
        var ctx = canvas.getContext("2d");

        let chartStatus = Chart.getChart(this.id);
        if (chartStatus != undefined) {
          chartStatus.destroy();
        }

        const calculateBarHeigtPlugin = {
          id: "calculateBarHeigtPlugin",
          beforeDraw: function (chart) {
            const bar1 = chart.getDatasetMeta(0)?.data?.[0] ?? {};
            const bar2 = chart.getDatasetMeta(0)?.data?.[1] ?? {};
            const y1 = bar1?.y ?? 0;
            const y2 = bar2?.y ?? 0;
            const distance = Math.abs(y2 - y1);
            updateBarHeightFunc(distance);
          },
        };

        const getLable = (tooltipItem) =>
          `${tooltipItem.label}: ${tooltipItem.raw || 0}}`;
        const getCropedLabel = (index, length = 10) => {
          const label = this.chart.labels[index] || "";
          return label.length <= length
            ? label
            : `${label.substring(0, length)}...`;
        };
        const externalTooltipHandler = (context) => {
          const { chart, tooltip } = context;
          const tooltipEl = this.getOrCreateTooltip(chart);
          tooltipEl.classList.add("chartjs-tooltip");
          if (tooltip.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }
          if (tooltip.body) {
            const titleLines = tooltip.title || [];
            const tableBody = document.createElement("tbody");
            titleLines.forEach((body, i) => {
              const colors = tooltip.labelColors[i];

              const span = document.createElement("span");
              span.style.background = colors.backgroundColor;
              span.style.borderColor = colors.borderColor;
              span.style.borderWidth = "2px";
              span.style.marginRight = "10px";
              span.style.height = "10px";
              span.style.width = "10px";
              span.style.display = "inline-block";

              const tr2 = document.createElement("tr");
              tr2.style.backgroundColor = "inherit";
              tr2.style.borderWidth = 0;

              const tr2td = document.createElement("td");
              tr2td.colSpan = 2;
              tr2td.style.fontSize = "0.85rem";
              tr2td.style.fontWeight = "700";
              const title = tooltip.dataPoints[0]
                ? tooltip.dataPoints[0].label
                : "";
              const lbl = document.createTextNode(title);
              // lbl.appendData(title);
              tr2td.appendChild(lbl);
              tr2.append(tr2td);

              const tr = document.createElement("tr");
              tr.style.backgroundColor = "inherit";
              tr.style.borderWidth = 0;

              const td = document.createElement("td");
              td.style.borderWidth = 0;
              td.style.fontSize = "0.75rem";
              const td2 = document.createElement("td");
              td2.style.borderWidth = 0;
              td2.style.fontSize = "0.75rem";
              td2.style.fontWeight = "500";
              const text = document.createTextNode(body);

              text.appendData(
                tooltip.dataPoints[0]
                  ? `: ${tooltip.dataPoints[0].formattedValue}`
                  : ""
              );
              td.appendChild(span);
              td2.appendChild(text);
              tr.appendChild(td);
              tr.appendChild(td2);
              tableBody.appendChild(tr2);
              tableBody.appendChild(tr);
            });
            const tableRoot = tooltipEl.querySelector("table");

            // Remove old children
            while (tableRoot.firstChild) {
              tableRoot.firstChild.remove();
            }

            tableRoot.appendChild(tableBody);
          }
          const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

          // Display, position, and set styles for font
          tooltipEl.style.opacity = 1;
          tooltipEl.style.transition = "opacity 0.5s ease-in-out";
          tooltipEl.style.left = (positionX + tooltip.caretX) / 1.4 + "px";
          tooltipEl.style.top = positionY + tooltip.caretY + "px";
          tooltipEl.style.font = tooltip.options.bodyFont.string;
          tooltipEl.style.padding =
            tooltip.options.padding + "px " + tooltip.options.padding + "px";
          tooltipEl.style.minWidth = tooltip.width / 1.75 + "px";
        };
        const chartDatasetLable = this.chart?.datasets?.label;
        const nameCropValue = this.nameCropValue;
        const barCursorType = this.barCursorType;
        const minmax = {};
        minmax["max"] = Math.max(
          0,
          ...(this.chart?.datasets?.data?.cases ?? [])
        );
        minmax["min"] = Math.min(
          0,
          ...(this.chart?.datasets?.data?.cases ?? [])
        );

        const magnitude = Math.pow(10, Math.floor(Math.log10(minmax["max"])));

        // Step 3: Round up rawMax to a "nice" roundedMax
        const roundedMax = Math.ceil(minmax["max"] / magnitude) * magnitude;

        const tickInterval = Math.trunc(roundedMax / 4);
        // const tickInterval = roundedMax / 4;
        // var dataLabels = this.chart?.datasets?.data?.labels
        // var rdataLabels = this.chart.datasets?.rdata?.labels

        new Chart(ctx, {
          type: "bar",
          data: {
            labels: this.chart.labels,
            datasets: [
              {
                label: this.chart?.datatype,
                weight: 5,
                borderWidth: 0,
                borderRadius: 4,
                backgroundColor: this.chart?.chartColor,
                data: this.chart?.datasets?.data?.cases,
                fill: false,
              },
            ],
          },
          options: {
            onHover: (event, chartElement) => {
              event.native.target.style.cursor = chartElement[0]
                ? barCursorType
                : "default";
            },
            indexAxis: "y",
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false,
              },
              tooltip: {
                enabled: false,
                position: "nearest",
                external: externalTooltipHandler,
                callbacks: {
                  title: function () {
                    return chartDatasetLable || "";
                  },
                  label: function (tooltipItem) {
                    return getLable(tooltipItem);
                  },
                },
              },
              datalabels: {
                // align: 'bottom',
                // anchor: 'end',
                clip: true,
                clamp: true,
                color: function () {
                  return "#FFFFFF";
                },
                font: function () {
                  return {
                    size: 10,
                    weight: "bold",
                  };
                },
                // formatter: (value) => `${value}%`,
              },
            },
            scales: {
              y: {
                clip: false,
                grid: {
                  drawBorder: false,
                  display: true,
                  drawOnChartArea: true,
                  drawTicks: false,
                  borderDash: [5, 5],
                },
                ticks: {
                  display: false,
                  padding: 10,
                  color: "#9ca2b7",
                  callback: function (_value, index) {
                    return getCropedLabel(index, nameCropValue);
                  },
                },
                border: {
                  dash: [5],
                  display: false,
                },
              },
              x: {
                min: 0,
                max: roundedMax,
                grid: {
                  drawBorder: false,
                  display: false,
                  drawOnChartArea: true,
                  drawTicks: true,
                },
                ticks: {
                  stepSize: tickInterval,
                  display: true,
                  color: "#9ca2b7",
                  padding: 10,
                },
                border: {
                  display: false,
                },
              },
            },
            onClick: (_e, item) => {
              try {
                if (item && item.length > 0) {
                  const index = item[0].index;
                  if (this.onBarClick) {
                    this.onBarClick(index);
                  }
                }
              } catch (error) {
                const errorMessage = utils.handleError(error);
                if (errorMessage) {
                  this.$swal({
                    title: "Error!",
                    text: errorMessage,
                    icon: "error",
                    confirmButtonText: "Okay",
                    customClass: {
                      confirmButton: "btn bg-success",
                    },
                    buttonsStyling: false,
                  });
                }
              }
            },
          },
          plugins: [calculateBarHeigtPlugin],
        });
      }
    },
  },
};
</script>
<style scoped>
canvas {
  height: 100% !important;
  width: 100% !important;
}

.my-tooltip {
  position: relative;
  display: inline-block;
  /* If you want dots under the hoverable text */
}

.my-tooltip .my-tooltiptext {
  visibility: hidden;
  width: "auto";
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  text-align: center;
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 0.775rem;
  font-weight: 600;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
}

.my-tooltip:hover .my-tooltiptext {
  visibility: visible;
}

.bar-label-container h6 {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

@keyframes marquee {
  0% {
    left: 100%;
  }

  100% {
    left: 0;
    transform: translateX(-100%);
  }
}
</style>
